(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('salesProspects', {
        templateUrl: 'views/components/views/salesProspects/salesProspects.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'translateService', 'salesProspectsService', 'custactEditService', 'userService', function ($stateParams, translateService, salesProspectsService, custactEditService, userService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let argType = $stateParams.argtype;
            let argValue = $stateParams.argvalue;
            let fontSize = userService.fontSize;
            let salesSizeName = '';
            let salesPossibilityName = '';

            let translations = {
                size_description: '',
                probability_description: ''
            };

            vm.model = {
                fontSetting: {
                    textSize: fontSize,
                    textSizeSmall: (parseInt(fontSize.substr(0, fontSize.length - 2)) - 3).toString() + "px",
                    textSizeExtraSmall: (parseInt(fontSize.substr(0, fontSize.length - 2)) - 5).toString() + "px"
                },
                infoMatrix: {
                    background: '',
                    colour: '',
                    count: '',
                    description: ''
                },
                matrix: [],
                tableCellsSizes: {
                    records: [],
                    indexed: []
                },
                tableCellsPossibilities: [],
                tableCellsSalesOpportunities: [],
                itemsListSalesProspects: [],
                cellClicked: 0
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSalesSizes() {
                const list = await custactEditService.listSalesSizes();

                vm.model.tableCellsSizes.records = list;
                let counter = 1;

                vm.model.tableCellsSizes.records.forEach((item) => {
                    vm.model.tableCellsSizes.indexed[counter] = item;
                    counter += 1;
                });
            }

            async function loadSalesPossibilities() {
                vm.model.tableCellsPossibilities = await custactEditService.listSalesPossibilities();
            }

            async function loadSalesOpportunities() {
                const list = await salesProspectsService.listSalesOpportunities();

                vm.model.tableCellsSalesOpportunities = list;

                vm.model.tableCellsSalesOpportunities.forEach((item) => {
                    let itemColour = retrieveListItemColour('', '', item.salesopportunity_no);

                    item.background = itemColour.background;
                    item.color = itemColour.color;
                });
            }

            async function loadSalesProspects(id, salesPossibilityNo, salesSizeNo) {
                switch (id) {
                    case 'default':
                        vm.model.itemsListSalesProspects = await salesProspectsService.listSalesProspects({
                            argtype: argType,
                            argvalue: argValue,
                            sales_possibility_no: '0',
                            sales_size_no: '0'
                        });

                        vm.model.infoMatrix.count = vm.model.itemsListSalesProspects.length;
                        break;
                    case 'matrixClicked':
                        vm.model.itemsListSalesProspects = await salesProspectsService.listSalesProspects({
                            argtype: argType,
                            argvalue: argValue,
                            sales_possibility_no: salesPossibilityNo,
                            sales_size_no: salesSizeNo
                        });
                        break;
                    default:
                        break;
                }
            }

            async function loadCounts() {
                const list = await salesProspectsService.listCounts({
                    argtype: argType,
                    argvalue: argValue
                });

                prepareMatrix(list);
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region RETRIEVE COUNT FUNCTION

            function retrieveListItemCount(list, probability, consequence) {
                let count = 0;
                
                list.forEach((item) => {
                    if (item.sales_possibility_no == probability && item.sales_size_no == consequence) {
                        count = item.nbr;
                    }
                });
    
                return count;
            }

            // #endregion RETRIEVE COUNT FUNCTION

            // #region RETRIEVE COLOUR FUNCTION

            function retrieveListItemColour(probability, consequence, salesOpportunityNo) {
                let tableCell = {
                    background: '#B91114',
                    color: '#ffffff'
                };

                let cellNumber = probability + '_' + consequence + salesOpportunityNo;
                
                switch (cellNumber) {
                    /*RED*/
                    case '1_1':
                    case '1_2':
                    case '1_3':
                    case '2_1':
                    case '2_2':
                    case '3_1':
                    case '_4':
                        tableCell.background = '#B91114';
                        tableCell.color = '#ffffff';
                        //tableCell.background = '#0F9F0F';
                        //tableCell.color = '#FFFFFF';
                        break;
                    /*ORANGE*/
                    case '1_4':
                    case '1_5':
                    case '2_2':
                    case '2_3':
                    case '2_4':
                    case '3_2':
                    case '3_3':
                    case '4_1':
                    case '4_2':
                    case '5_1':
                    case '_3':
                        tableCell.background = '#FFAC22';
                        tableCell.color = '#000000';
                        //tableCell.background = '#F2E228';
                        //tableCell.color = '#000000';
                        break;
                    /*YELLOW*/
                    case '_2':
                    case '2_5':
                    case '3_4':
                    case '4_3':
                    case '5_2':
                        tableCell.background = '#F2E228';
                        tableCell.color = '#000000';
                        //tableCell.background = '#FFAC22';
                        //tableCell.color = '#000000';
                        break;
                    /*GREEN*/
                    default:
                        tableCell.background = '#0F9F0F';
                        tableCell.color = '#FFFFFF';
                        //tableCell.background = '#B91114';
                        //tableCell.color = '#ffffff';
                        break;
                }
                
                return tableCell;
            }

            // #endregion RETRIEVE COLOUR FUNCTION

            // #region PREPARE MATRIX FUNCTION

            function prepareMatrix(list) {
                vm.model.matrix = [];

                let probability = 5;
                let consequence = 1;

                for (probability = 5; probability > 0; probability--) {
                    consequence = 1;

                    for (consequence = 1; consequence < 6; consequence++) {
                        let tableCellBadge = {};
                        let tableCellColours = retrieveListItemColour(probability, consequence, '');

                        tableCellBadge.sales_possibility_no = probability;
                        tableCellBadge.sales_size_no = consequence;
                        tableCellBadge.background = tableCellColours.background;
                        tableCellBadge.color = tableCellColours.color;
                        tableCellBadge.count = retrieveListItemCount(list, probability, consequence);

                        vm.model.matrix[consequence + '_' + probability] = tableCellBadge;
                    }
                }
            }

            // #endregion PREPARE MATRIX FUNCTION

            // #region CLICK MATRIX CELL FUNCTION

            vm.clickMatrixCell = function (salesPossibilityNo, salesSizeNo, background, color, count) {
                vm.model.cellClicked += 1;

                vm.model.tableCellsSizes.records.forEach((item) => {
                    if (item.sales_size_no == salesSizeNo) {
                        salesSizeName = item.sales_size_name;
                    }
                });

                vm.model.tableCellsPossibilities.forEach((item) => {
                    if (item.sales_possibility_no == salesPossibilityNo) {
                        salesPossibilityName = item.sales_possibility_name;
                    }
                });

                vm.model.infoMatrix.background = background;
                vm.model.infoMatrix.colour = color;
                vm.model.infoMatrix.count = count;
                vm.model.infoMatrix.description = translations.size_description + ':' + ' ' + salesSizeName + ' ' + "\n\n" + ' ' + translations.probability_description + ':' + ' ' + salesPossibilityName + "\n";

                loadSalesProspects('matrixClicked', salesPossibilityNo, salesSizeNo);
            };

            // #endregion CLICK MATRIX CELL FUNCTION

            // #region SHOW ALL ITEMS LIST FUNCTION

            vm.showAllItems = function () {
                vm.model.cellClicked = 0;
                
                loadSalesProspects('default', '0', '0');
            };

            // #endregion SHOW ALL ITEMS LIST FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSalesSizes();
                loadSalesPossibilities();
                loadSalesOpportunities();
                loadSalesProspects('default', '0', '0');
                loadCounts();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
